import { useEffect } from 'react';
import SEOHead from '@/components/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PortfolioPreview from './components/PortfolioPreview';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

export default function Home() {
  const schema = [
    {
      '@type': 'WebPage',
      name: 'Jéssica Bonini Fotógrafa',
      description: 'Jéssica Bonini Fotógrafa há 10 anos criando memórias. Especializada em casamentos, sessão família, pré-wedding e eventos corporativos.',
      url: SITE_URL,
      inLanguage: 'pt-BR',
    },
    {
      '@type': 'LocalBusiness',
      '@id': `${SITE_URL}/#business`,
      name: 'Jéssica Bonini Fotógrafa',
      description: 'Fotografia profissional especializada em casamentos, pré-wedding, sessão família e eventos corporativos.',
      url: SITE_URL,
      telephone: '+55-15-98817-5816',
      email: 'contato@jessicabonini.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Sorocaba',
        addressRegion: 'SP',
        addressCountry: 'BR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '-23.5015',
        longitude: '-47.4526',
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          opens: '10:00',
          closes: '18:00',
        },
      ],
      priceRange: 'R$',
      areaServed: {
        '@type': 'City',
        name: 'Sorocaba',
      },
      sameAs: [
        'https://www.instagram.com/jessicaboninifotografa',
      ],
    },
  ];

  return (
    <div className="min-h-screen">
      <SEOHead
        title="Jéssica Bonini Fotógrafa | Casamentos, Sessão Família & Pré-Wedding"
        description="Jéssica Bonini Fotógrafa há 10 anos criando memórias. Especializada em casamentos, sessão família, pré-wedding e eventos corporativos. Transforme seus momentos em memórias eternas."
        keywords="fotografia, casamento, pré-wedding, sessão família, fotógrafa, jessica bonini, sorocaba"
        canonicalPath="/"
        ogType="website"
        schema={schema}
      />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <PortfolioPreview />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}